import { accounting } from '../../api/accounting';
import { IframeWindow } from '.';

export class Accounting implements accounting.Api {
  constructor(private iframe: IframeWindow) {}

  createTimeEntry(request: accounting.CreateTimeEntryRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createTimeEntry',
      args: request,
    });
  }

  createFeeEntry(request: accounting.CreateFeeEntryRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createFeeEntry',
      args: request,
    });
  }

  createCostRecovery(request: accounting.CreateCostRecoveryEntryRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createCostRecovery',
      args: request,
    });
  }

  createInvoice(request: accounting.CreateInvoiceRequest): Promise<boolean> {
    return this.iframe.twoWayCall<accounting.CreateInvoiceRequest, boolean>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'accounting.createInvoice',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        return response;
      }
    );
  }

  createOfficeReceipt(request: accounting.CreateOfficeReceiptRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createOfficeReceipt',
      args: request,
    });
  }

  createOfficePayment(request: accounting.CreateOfficePaymentRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createOfficePayment',
      args: request,
    });
  }

  createOfficeJournal(request: accounting.CreateOfficeJournalRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createOfficeJournal',
      args: request,
    });
  }

  createTrustReceipt(request: accounting.CreateTrustReceiptRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createTrustReceipt',
      args: request,
    });
  }

  createTrustPayment(request: accounting.CreateTrustPaymentRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createTrustPayment',
      args: request,
    });
  }

  createTrustJournal(request: accounting.CreateTrustJournalRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createTrustJournal',
      args: request,
    });
  }

  createTrustToOffice(request: accounting.CreateTrustToOfficeRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createTrustToOffice',
      args: request,
    });
  }
  createOfficePaymentRequest(request: accounting.CreateNewOfficePaymentRequestRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createOfficePaymentRequest',
      args: request,
    });
  }
  createTrustPaymentRequest(request: accounting.CreateNewTrustPaymentRequestRequest): void {
    this.iframe.postMessage({
      command: 'accounting.createTrustPaymentRequest',
      args: request,
    });
  }

  reloadFinancialSummary(request: accounting.ReloadFinancialSummaryRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadFinancialSummary',
      args: request,
    });
  }

  reloadTimeFeeList(request: accounting.ReloadTimeFeeListRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadTimeFeeList',
      args: request,
    });
  }

  reloadOfficeLedger(request: accounting.ReloadOfficeLedgerRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadOfficeLedger',
      args: request,
    });
  }

  reloadAnticipatedPaymentList(request: accounting.ReloadAnticipatedPaymentListRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadAnticipatedPaymentList',
      args: request,
    });
  }

  reloadCostRecoveryList(request: accounting.ReloadCostRecoveryListRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadCostRecoveryList',
      args: request,
    });
  }

  reloadTrustLedger(request: accounting.ReloadTrustLedgerRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadTrustLedger',
      args: request,
    });
  }

  reloadControlledMoneyList(request: accounting.ReloadControlledMoneyListRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadControlledMoneyList',
      args: request,
    });
  }

  reloadPowerMoneyList(request: accounting.ReloadPowerMoneyListRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadPowerMoneyList',
      args: request,
    });
  }

  reloadTransitMoneyList(request: accounting.ReloadTransitMoneyListRequest): void {
    this.iframe.postMessage({
      command: 'accounting.reloadTransitMoneyList',
      args: request,
    });
  }

  openFee(request: accounting.OpenFeeRequest): void {
    if (request.isAutoTime) request.timed = true;

    this.iframe.postMessage({
      command: 'accounting.openFee',
      args: request,
    });
  }

  createTimeEntryV2(request: accounting.CreateTimeEntryRequest): Promise<accounting.CreateTimeEntryResponse> {
    throw new Error('Method not implemented.');
  }
  createFeeEntryV2(request: accounting.CreateFeeEntryRequest): Promise<accounting.CreateFeeEntryResponse> {
    throw new Error('Method not implemented.');
  }
  createCostRecoveryV2(
    request: accounting.CreateCostRecoveryEntryRequest
  ): Promise<accounting.CreateCostRecoveryResponse> {
    throw new Error('Method not implemented.');
  }
  createInvoiceV2(request: accounting.CreateInvoiceRequest): Promise<accounting.CreateInvoiceResponse> {
    throw new Error('Method not implemented.');
  }
  createOfficeReceiptV2(
    request: accounting.CreateOfficeReceiptRequest
  ): Promise<accounting.CreateOfficeReceiptResponse> {
    throw new Error('Method not implemented.');
  }
  createOfficePaymentV2(
    request: accounting.CreateOfficePaymentRequest
  ): Promise<accounting.CreateOfficePaymentResponse> {
    throw new Error('Method not implemented.');
  }
  createOfficeJournalV2(
    request: accounting.CreateOfficeJournalRequest
  ): Promise<accounting.CreateOfficeJournalResponse> {
    throw new Error('Method not implemented.');
  }
  createTrustReceiptV2(request: accounting.CreateTrustReceiptRequest): Promise<accounting.CreateTrustReceiptResponse> {
    throw new Error('Method not implemented.');
  }
  createTrustPaymentV2(request: accounting.CreateTrustPaymentRequest): Promise<accounting.CreateTrustPaymentResponse> {
    throw new Error('Method not implemented.');
  }
  createTrustJournalV2(request: accounting.CreateTrustJournalRequest): Promise<accounting.CreateTrustJournalResponse> {
    throw new Error('Method not implemented.');
  }
  createTrustToOfficeV2(
    request: accounting.CreateTrustToOfficeRequest
  ): Promise<accounting.CreateTrustToOfficeResponse> {
    throw new Error('Method not implemented.');
  }
  createOfficePaymentRequestV2(
    request: accounting.CreateNewOfficePaymentRequestRequest
  ): Promise<accounting.CreateNewOfficePaymentRequestResponse> {
    throw new Error('Method not implemented.');
  }
  createTrustPaymentRequestV2(
    request: accounting.CreateNewTrustPaymentRequestRequest
  ): Promise<accounting.CreateNewTrustPaymentRequestResponse> {
    throw new Error('Method not implemented.');
  }
}
